import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack } from "@mui/material";
import { useForm } from "react-hook-form";
import { TextFieldElement } from "react-hook-form-mui";
import { useTranslation } from "react-i18next";

type ConfirmRejectDialogProps = {
    open: boolean;
    onClose: () => void;
    onConfirm: (rejectionReason: string) => Promise<void>;
    loading: boolean;
};

type FormValues = {
    rejectionReason: string;
};

export function ConfirmRejectDialog({ open, onClose, onConfirm, loading }: ConfirmRejectDialogProps) {
    const { t } = useTranslation("project");
    const {
        control,
        handleSubmit,
        reset,
        formState: { isValid },
    } = useForm<FormValues>({
        defaultValues: {
            rejectionReason: "",
        },
    });

    const onSubmit = async (values: FormValues) => {
        await onConfirm(values.rejectionReason);
        reset();
    };

    const handleClose = () => {
        if (!loading) {
            reset();
            onClose();
        }
    };

    return (
        <Dialog open={open} onClose={handleClose}>
            <form onSubmit={handleSubmit(onSubmit)}>
                <DialogTitle>{t("projectReviewVisitV2.rejectButton.dialog.title")}</DialogTitle>

                <DialogContent>
                    <Stack spacing={2}>
                        <Alert severity="warning">{t("projectReviewVisitV2.rejectButton.dialog.warningMessage")}</Alert>

                        <TextFieldElement
                            name="rejectionReason"
                            control={control}
                            label={t("projectReviewVisitV2.rejectButton.dialog.reasonLabel")}
                            multiline
                            minRows={4}
                            fullWidth
                            required
                            rules={{
                                required: t("projectReviewVisitV2.rejectButton.dialog.reasonRequired"),
                            }}
                        />
                    </Stack>
                </DialogContent>

                <DialogActions>
                    <Button onClick={handleClose} disabled={loading}>
                        {t("projectReviewVisitV2.rejectButton.dialog.cancel")}
                    </Button>
                    <Button type="submit" variant="outlined" color="error" disabled={loading || !isValid}>
                        {t("projectReviewVisitV2.rejectButton.dialog.confirm")}
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    );
}
